import React from 'react';
import BuyMegaMenu from '../../components/Navigation/BuyMegaMenu/BuyMegaMenu';
import SellMegaMenu from '../../components/Navigation/SellMegaMenu/SellMegaMenu';

interface LinksProps {
  mobile?: boolean;
}

export default function Links({ mobile = false }: LinksProps) {
  return (
    <ul
      className="navbar-nav me-auto mb-2 mb-lg-0 navbar-ul mx-auto d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-start justify-content-md-center w-100"
    >
      <BuyMegaMenu mobile={mobile} />
      <SellMegaMenu mobile={mobile} />
    </ul>
  );
}
